import { lazy } from 'react';
import { RouteObject, Navigate } from 'react-router-dom';
import { ModuleGuard } from '@shared/module-kit';

const HealthMonitoringPage = lazy(() => import('./pages/HealthMonitoringPage'));
const HealthAlertsPage = lazy(() => import('./pages/HealthAlertsPage'));
const PredictiveSupportPage = lazy(() => import('./pages/PredictiveSupportPage'));
const UsageAlertsPage = lazy(() => import('./pages/UsageAlertsPage'));
const HealthDashboardPage = lazy(() => import('./pages/HealthDashboardPage'));

export const ProactiveRoutes: RouteObject = {
  path: 'proactive',
  element: <ModuleGuard moduleId="support.proactive" />,
  handle: { crumb: 'Proactive Support' },
  children: [
    { index: true, element: <Navigate to="health-monitoring" replace /> },
    { path: 'health-monitoring', element: <HealthMonitoringPage />, handle: { crumb: 'Health Monitoring' } },
    { path: 'health-alerts', element: <HealthAlertsPage />, handle: { crumb: 'Health Alerts' } },
    { path: 'predictive-support', element: <PredictiveSupportPage />, handle: { crumb: 'Predictive Support' } },
    { path: 'usage-alerts', element: <UsageAlertsPage />, handle: { crumb: 'Usage Alerts' } },
    { path: 'health-dashboard', element: <HealthDashboardPage />, handle: { crumb: 'Health Dashboard' } },
  ],
};
